<template>
  <ag-grid-vue
    v-bind="agWorkShifts"
    ref="agWorkShifts"
    style="height: 65vh;"
    class="ag-theme-alpine"
    @cellEditRequest="onCellEditRequest"
  />
</template>

<script>
/* eslint-disable vue/no-unused-components */
import { getFirestore, collection, query, orderBy, getDocs, doc, setDoc } from "firebase/firestore";
import { AgGridVue } from "ag-grid-vue";
import BaseLoader from "@/components/BaseLoader.vue";
import EmptySection from "@/components/EmptySection.vue";
import { AG_GRID_LOCALE_ES } from '@ag-grid-community/locale';
import EditorTime from "@/components/AgGrid/EditorTime.vue";

  export default {
    name: 'TableWorkShifts',
    components: {
      AgGridVue,
      BaseLoader,
      EmptySection,
      EditorTime,
    },
    data() {
      return {
        agWorkShifts: {
          rowData: null,
          columnDefs: [
            {
              headerName: "Nombre",
              field: "name",
              filter: "agTextColumnFilter",
            },
            {
              headerName: "Hora de entrada",
              field: "start",
              filter: "agTextColumnFilter",
              editable: true,
              cellEditor: "EditorTime",
              tooltipValueGetter: () => 'Doble click para editar',
            },
            {
              headerName: "Hora de salida",
              field: "end",
              filter: "agTextColumnFilter",
              editable: true,
              cellEditor: "EditorTime",
              tooltipValueGetter: () => 'Doble click para editar',
            },
            {
              headerName: "Número de descansos",
              field: "break_lunch",
              filter: "agNumberColumnFilter",
              cellStyle: { cursor: 'text' },
              tooltipValueGetter: () => 'Doble click para editar',
              editable: true,
              cellEditorParams: {
                min: 0,
                max: 2
              }
            },
          ],
          defaultColDef: {
            suppressHeaderMenuButton: true,
            resizable: true,
            filter: true, 
            floatingFilter: true,
          },
          autoSizeStrategy: {
            type: 'fitGridWidth',
            defaultMinWidth: 100,
          },
          readOnlyEdit:true,
          stopEditingWhenCellsLoseFocus:true,
          pagination: true,
          paginationPageSize: 1000,
          paginationPageSizeSelector: [100, 500, 1000, 2000],
          loadingOverlayComponent: "BaseLoader",
          noRowsOverlayComponent: "EmptySection",
          rowSelection: "single",
          suppressCellFocus: true,
          enableCellTextSelection: true,
          alwaysShowVerticalScroll: true,
          localeText: AG_GRID_LOCALE_ES,
        },
      }
    },
    created() {
      this.getWorkShifts();
    },
    methods: {
      getWorkShifts() {
        const db = getFirestore();
        const coll = collection(db, "work_shifts");
        const qry = query(coll, orderBy("name", "asc"));

        getDocs(qry).then((snapshot) => {
          if (!snapshot.empty) {
            this.agWorkShifts.rowData = snapshot.docs.map((doc) => {
              return doc.data();
            });
          } else {
            this.agWorkShifts.rowData = [];
          }
        });
      },
      onCellEditRequest({newValue, data, column}){
        if(newValue === undefined || newValue === null) return;
        this.$swal({
          title: `¿Editar ${data.name}?`,
          text : `El nuevo valor de ${column.colDef.headerName} será: ${newValue}`,
          icon: 'question',
          confirmButtonText: "Si, editar",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
        }).then((result) => {
          if (result.isConfirmed) {
            const db = getFirestore();
            const coll = collection(db, "work_shifts");
            const docRef = doc(coll, data.name);
            setDoc(docRef, {[column.colId]: newValue}, { merge: true })
            .then(() => {
              this.getWorkShifts();
              this.$swal({
                title: "Turno actualizado",
                text: `${data.name} ha sido actualizado correctamente`,
                icon: "success",
              });
            }).catch((error) => {
              console.error("Error", error);
              this.$swal({
                title: "Error",
                text: `Ocurrió un error al actualizar ${data.name}`,
                icon: "error",
              });
            });
          }
        });
      }
    },
  }
</script>

<style>
</style>